import BannerStatus from '@/components/DesignLibrary/Atoms/BannerStatus';
import { FC } from 'react';
import s from '../InvoicePreview.module.scss';

const Banner: FC<{
  isEdited: boolean;
  isSkipped: boolean;
  isVoided: boolean;
  isPaid: boolean;
  isPaymentFailed: boolean;
}> = ({ isPaid, isSkipped, isVoided, isPaymentFailed, isEdited }) => {
  if (!(isSkipped || isVoided || isPaid || isPaymentFailed || isEdited)) return null;
  return (
    <div className={s.headerBanner}>
      {isSkipped && <>This invoice request has been skipped. No action required. </>}
      {isPaymentFailed && <BannerStatus status="error" label="Your payment failed. Please re-submit it here." />}
      {isVoided && <BannerStatus status="error" label="Invoice voided" />}
      {isEdited && <BannerStatus status="error" label="This invoice has been edited and is no longer payable." />}
      {isPaid && <BannerStatus status="success" label="Invoice paid" />}
    </div>
  );
};

export default Banner;
